<div style="overflow-y: scroll; max-height: 80vh;" class="custom-scrollbar">
  <h1 class="mat-display-1" mat-dialog-title style="margin-bottom: 1rem;">Konto erstellen</h1>
  <mat-divider class="headline-divider"></mat-divider>

  <mat-vertical-stepper #stepper (animationDone)="setFocus()" (selectionChange)="setTargetId($event)" [linear]="true">
    <mat-step [stepControl]="loginInformationForm">
      <form (keyup.enter)="move(1)" tabindex="0" [formGroup]="loginInformationForm">
        <ng-template matStepLabel>Login Information</ng-template>
        <div class="form-field-wrapper">
          <mat-form-field class="w100" appearance="outline">
            <mat-label>E-Mail</mat-label>
            <input formControlName="email" id="input0" matInput placeholder="" required type="email" autocomplete="username">
            @if (loginSubmitted && loginInformationForm.controls.email.hasError('required')) {
              <mat-hint
                class="warning"
                >
                E-Mail Adresse ist verpflichtend
              </mat-hint>
            }
            @if (loginSubmitted && loginInformationForm.controls.email.hasError('minlength')) {
              <mat-hint
                class="warning"
                >
                Eingabe ist keine gültige E-Mail Adresse
              </mat-hint>
            }
          </mat-form-field>
          <div class="form-field-line-half">
            <mat-form-field appearance="outline">
              <mat-label>Passwort</mat-label>
              <input [type]="hidePw ? 'password' : 'text'" formControlName="pw1" matInput placeholder="" required
                autocomplete="new-password">
                <mat-icon (click)="hidePw = !hidePw" matSuffix>{{hidePw ? 'visibility_off' : 'visibility'}}</mat-icon>
                @if (loginSubmitted && loginInformationForm.controls.pw1.hasError('required')) {
                  <mat-hint
                    class="warning">
                    Passwort ist verpflichtend
                  </mat-hint>
                }
                @if (loginSubmitted && loginInformationForm.controls.pw1.hasError('minlength')) {
                  <mat-hint
                    class="warning">
                    Passwort muss mindestens 8 Zeichen enthalten
                  </mat-hint>
                }
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Passwort erneut eingeben</mat-label>
                <input [type]="hidePw2 ? 'password' : 'text'" formControlName="pw2" matInput placeholder=""
                  required autocomplete="new-password">
                  @if (loginSubmitted && loginInformationForm.controls.pw2.hasError('required')) {
                    <mat-hint
                      class="warning">
                      Passwort ist verpflichtend
                    </mat-hint>
                  }
                  @if (loginSubmitted && loginInformationForm.controls.pw2.hasError('minlength')) {
                    <mat-hint
                      class="warning">
                      Passwort muss mindestens 8 Zeichen enthalten
                    </mat-hint>
                  }
                  @if (loginSubmitted &&
                    loginInformationForm.hasError('mismatching') &&
                    !loginInformationForm.controls.pw2.hasError('required') &&
                    !loginInformationForm.controls.pw2.hasError('minlength')) {
                    <mat-hint
                      class="warning">
                      Passwörter stimmen nicht überein
                    </mat-hint>
                  }
                  <mat-icon (click)="hidePw2 = !hidePw2" matSuffix>{{hidePw2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
              </div>
            </div>
          </form>
          <div style="display: flex; flex-direction: row-reverse">
            <button (click)="move(1); name._elementRef.nativeElement.focus()" color="primary" mat-button mat-raised-button>
              Weiter
            </button>
          </div>
        </mat-step>
        <mat-step [stepControl]="personalInformationForm">
          <form (keyup.enter)="submit()" tabindex="0" [formGroup]="personalInformationForm">
            <ng-template matStepLabel>Persönliche Information</ng-template>
            <div class="form-field-wrapper">
              <span style="padding: 5px; text-align: center; margin-bottom: 1rem;">
                Die Angabe dieser Informationen ist optional und erhöht den Schutz Ihres Accounts.
                Bitte beachten Sie diesbezüglich unsere <a href="https://www.osd.at/datenschutz/">Datenschutzerklärung</a>.
              </span>
              <div class="form-field-line-half">
                <mat-form-field #name appearance="outline">
                  <mat-label>Vorname</mat-label>
                  <input formControlName="firstName" id="input1" matInput placeholder="" type="text">
                  @if (personalSubmitted && personalInformationForm.controls.firstName.hasError('maxlength')) {
                    <mat-hint
                      class="warning">
                      Nur 255 Zeichen erlaubt
                    </mat-hint>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Nachname</mat-label>
                  <input formControlName="lastName" matInput placeholder="" type="text">
                  @if (personalSubmitted && personalInformationForm.controls.lastName.hasError('maxlength')) {
                    <mat-hint
                      class="warning">
                      Nur 255 Zeichen erlaubt
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
              <div class="form-field-line-third">
                <mat-form-field appearance="outline">
                  <mat-label>Land</mat-label>
                  <input formControlName="country" matInput placeholder="" type="text">
                  @if (personalSubmitted && personalInformationForm.controls.country.hasError('maxlength')) {
                    <mat-hint
                      class="warning">
                      Nur 255 Zeichen erlaubt
                    </mat-hint>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Stadt</mat-label>
                  <input formControlName="city" matInput placeholder="" type="text">
                  @if (personalSubmitted && personalInformationForm.controls.city.hasError('maxlength')) {
                    <mat-hint
                      class="warning">
                      Nur 255 Zeichen erlaubt
                    </mat-hint>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>PLZ</mat-label>
                  <input formControlName="zip" matInput placeholder="" type="number" max="999999">
                  @if (personalSubmitted && personalInformationForm.controls.zip.hasError('zipCodeTooBig')) {
                    <mat-hint
                      class="warning">
                      Nur 6 Zeichen erlaubt
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
              <mat-form-field class="w100" appearance="outline">
                <mat-label>Straße</mat-label>
                <input formControlName="street" matInput placeholder="" type="text">
                @if (personalSubmitted && personalInformationForm.controls.street.hasError('maxlength')) {
                  <mat-hint
                    class="warning">
                    Nur 255 Zeichen erlaubt
                  </mat-hint>
                }
              </mat-form-field>
            </div>
          </form>
          <div class="register-button-group">
            <button (click)="submit()" color="primary" mat-button mat-raised-button>Konto erstellen</button>
            <button (click)="move(0)" mat-button mat-raised-button>Zurück</button>
          </div>
        </mat-step>
      </mat-vertical-stepper>
    </div>
